
<app-spinner *ngIf="allComponents.length === 0" [sizeClass]="'large'"></app-spinner>
<app-selection *ngIf="allComponents.length !== 0" [componentType]="'transformer'"></app-selection>

